
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <process-edit *ngSwitchCase="true"></process-edit>
            <process-details *ngSwitchCase="false"></process-details>
        </div>
    </ng-template>  
</main-form-modal>